import React from 'react';
import Select from 'react-select';
import { ROLE_ADMIN, ROLE_ENGINNER, ROLE_USER } from '../../../Constants/ConstantsOptics';

const CantonContainerViewing = ({handleCantonChange, canton, customStyles,
      handleRegionChange, regions, area, handleClickCanton, loadingCunton,
      selectedRegionRef, selectedAreaRef,handleAreaChange,selectCantonIsСhange,
      selectedRegoin,selectedArea}) => {

        
  return (
    <div className='equipmentDiv' style={{ marginTop: "10px" }}>
      <label className='textTitleDrawer' style={{ fontSize: "16px",textShadow: '2px 2px 4px #000000' }}>Территория</label>
      <hr className="horizontalLineDrawer" style={{ marginTop: "5px" }} />
      <Select
        className="selectSearchDrawer"
        value={selectCantonIsСhange || ""}
        onChange={handleCantonChange}
        options={canton.map(option => ({ value: option, label: option }))}
        isSearchable={true}
        styles={customStyles}
        placeholder="Округ"
      />

      <select className="selectStyleDrawer" style={{ marginBottom: "5px" }} onChange={handleRegionChange} ref={selectedRegionRef} value={selectedRegoin || ""}  >
        <option value="null">Регион</option>
        {regions.map((region, index) => (
          <option key={index} value={region}>
            {region}
          </option>
        ))}
      </select>

      <select className="selectStyleDrawer" style={{ marginBottom: "5px", marginLeft: "5px",marginRight: "5px" }} onChange={handleAreaChange}  ref={selectedAreaRef} value={selectedArea || ""}>
        <option value="null">Ветка</option>
        {area.map((area, index) => (
          <option key={index} value={area}>
            {area}
          </option>
        ))}
      </select>

      <button className='buttonAutoTopology' onClick={handleClickCanton} >Отобразить</button>
      {loadingCunton && <img src="loading.gif" alt="Загрузка..." width="30" height="30" />}
    </div>
  );
}

export default CantonContainerViewing;